import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  createSubCategory,
  updateSubCategory,
  getCategoriesDropdown,
} from "./SubCategoryService";

function SubCategoryForm({ editData, refreshList, clearEdit }) {
  const [formData, setFormData] = useState({
    subCategoryName: "",
    categoryId: "",
    isActive: true,
  });

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    loadCategories();
  }, []);

  useEffect(() => {
    if (editData) {
      setFormData(editData);
    }
  }, [editData]);

  const loadCategories = async () => {
    try {
      const res = await getCategoriesDropdown();
      const sorted = res.data.sort((a, b) =>
        a.categoryName.localeCompare(b.categoryName)
      );

      setCategories(
        sorted.map((cat) => ({
          value: cat.categoryId,
          label: cat.categoryName,
        }))
      );
    } catch (error) {
      toast.error("Failed to load categories");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editData) {
        await updateSubCategory(editData.subCategoryId, formData);
        toast.success("SubCategory Updated Successfully");
      } else {
        await createSubCategory(formData);
        toast.success("SubCategory Created Successfully");
      }

      refreshList();
      clearEdit();
      setFormData({
        subCategoryName: "",
        categoryId: "",
        isActive: true,
      });
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="card shadow-lg p-4 rounded-4">
      <h5 className="mb-3 border-bottom border-1 pb-2">
        {editData ? "Update SubCategory" : "Add SubCategory"}
      </h5>

      <form onSubmit={handleSubmit}>
        
        <div className="mb-3">
          <label>Category</label>
          <Select
            options={categories}
            value={categories.find(
              (cat) => cat.value === formData.categoryId
            )}
            onChange={(selected) =>
              setFormData({
                ...formData,
                categoryId: selected.value,
              })
            }
            placeholder="Select Category"
          />
        </div>
        
        <div className="mb-3">
          <label>SubCategory Name</label>
          <input
            type="text"
            className="form-control"
            value={formData.subCategoryName}
            onChange={(e) =>
              setFormData({
                ...formData,
                subCategoryName: e.target.value,
              })
            }
            required
          />
        </div>
        
        <div className="form-check mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            checked={formData.isActive}
            onChange={(e) =>
              setFormData({
                ...formData,
                isActive: e.target.checked,
              })
            }
          />
          <label className="form-check-label">Active</label>
        </div>

        <button className="btn btn-primary w-100">
          {editData ? "Update" : "Save"}
        </button>
      </form>
    </div>
  );
}

export default SubCategoryForm;